import React from "react";
import { usePageTracking } from "../hooks/usePageTracking";
import { HomeHeader } from "../components/home/HomeHeader";
import { Hero } from "../components/home/Hero";
import { TrustBar } from "../components/home/TrustBar";
import { TrustStrip } from "../components/home/TrustStrip";
import { StatStrip } from "../components/home/StatStrip";
import { WhyAppealsFail } from "../components/home/WhyAppealsFail";
import { Qualifier } from "../components/home/Qualifier";
import { ServicesGrid } from "../components/home/ServicesGrid";
import { HowItWorks } from "../components/home/HowItWorks";
import { ProofSection } from "../components/home/ProofSection";
import { PricingSection } from "../components/home/PricingSection";
import { DisclaimerCallout } from "../components/home/DisclaimerCallout";
import { FAQSection } from "../components/home/FAQSection";
import { PeopleAlsoAsk } from "../components/home/PeopleAlsoAsk";
import { FounderBlock } from "../components/home/FounderBlock";
import { FinalCTA } from "../components/home/FinalCTA";
import { HomeFooter } from "../components/home/HomeFooter";
import ExitIntentModal from "../components/ExitIntentModal";

export default function PremiumHomepage() {
  usePageTracking("Home", { category: "home" });
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <HomeHeader />
      <main>
        <Hero />
        <TrustBar />
        <TrustStrip />
        <StatStrip />
        <WhyAppealsFail />
        <Qualifier />
        <ServicesGrid />
        <HowItWorks />
        <ProofSection />
        <FounderBlock />
        <PricingSection />
        <div id="disclaimer">
          <DisclaimerCallout />
        </div>
        <FAQSection />
        <PeopleAlsoAsk />
        <FinalCTA />
      </main>
      <HomeFooter />
      <ExitIntentModal />
    </div>
  );
}
